import { currentFirebaseProjectId } from "./firebase";

const buildLogsQueryString = (searchTerm: string): string => {
  const escaped = searchTerm.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  return `SEARCH%28"${escaped}"%29`;
};

export const getGcpLogsConsoleUrl = (searchTerm: string): string => {
  const trimmed = searchTerm.trim();
  if (!trimmed) {
    return "";
  }
  const query = buildLogsQueryString(trimmed);
  const encodedQuery = encodeURIComponent(query);
  return `https://console.cloud.google.com/logs/query;query=${encodedQuery}?project=${currentFirebaseProjectId}`;
};
